// Shared handler for the "Price revealed in N days / Log in to view Price
// Early" badge on product cards (see syc-product-card.liquid and
// syc-card-builder.js). New Customer Accounts hosts login/signup on
// shopify.com and can't be embedded in an on-page modal (Shopify blocks
// framing it, the same way "Sign in with Google" can't be iframed), so
// instead of navigating the shopper away from the page they were browsing,
// this opens it in a new tab and reloads the original page once it detects
// they've logged in - no manual "come back and refresh" needed.
(function () {
    var pendingLoginCheck = false;

    function isLoggedIn(callback) {
        fetch('/account', { credentials: 'same-origin' })
            .then(function (res) {
                callback(res.ok && res.url.indexOf('/account') !== -1 && res.url.indexOf('login') === -1);
            })
            .catch(function () { callback(false); });
    }

    document.addEventListener('visibilitychange', function () {
        if (!pendingLoginCheck || document.visibilityState !== 'visible') return;
        isLoggedIn(function (loggedIn) {
            if (loggedIn) {
                pendingLoginCheck = false;
                window.location.reload();
            }
        });
    });

    window.handleSycLoginCta = function (url) {
        pendingLoginCheck = true;
        window.open(url, '_blank', 'noopener,noreferrer');
    };
})();
